import { useEffect } from "react";
export default function DownloadLink(props) {
    useEffect(function() {
        var downloadFile = function() {
            var fileName = props.url.substring(props.url.lastIndexOf("/") + 1);
            var link = document.createElement("a");
            link.href = props.url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };
        // Trigger the download automatically when the component mounts
        downloadFile();
    }, [
        props.url
    ]);
    // No need to render anything since the download is triggered automatically
    return null;
}
